<template>
  <div class="mainCard">
    <el-table
      :data="respondants"
      style="width: 100%;"
      class="clear-table mainCard"
    >
      <el-table-column
        prop="group"
        label="Breakout Group"
      />
      <el-table-column
        prop="status"
        label="Status"
      />
      <el-table-column
        prop="average"
        label="Average Growth"
      />
      <el-table-column
        label="Group Member"
        width="300"
      >
        <template slot-scope="scope">
          {{ scope.row.group_members.join(', ') }}
        </template>
      </el-table-column>
    </el-table>

    <div class="actionButton">
      <el-button
        type="primary"
        round
        @click="seeReport"
      >
        See detailed LGPR report
      </el-button>
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  props: {
    lgpr: {
      type: Object,
      default() {
        return {
          id: 0,
          number: 0,
          status: 'draft',
          start_date: this.$moment().format('YYYY-MM-DD'),
          end_date: null,
          reminder_1: null,
          reminder_2: null,
          reminder_3: null,
        };
      },
    },
  },

  data() {
    return {
      respondants: [
        {
          group: 'Self',
          status: '1/1',
          average: '1.0',
          group_members: ['Taylor Lee'],
        },
        {
          group: 'Manager',
          status: '1/1',
          average: '1.0',
          group_members: ['Karl Smith'],
        },
        {
          group: 'Peers',
          status: '4/4',
          average: '0.8',
          group_members: ['Catherine Laurences', 'Bob Smith', 'Minsun Jang', 'Peter White'],
        },
        {
          group: 'Direct reports',
          status: '3/3',
          average: '1.0',
          group_members: ['Yongsook Lee', 'Kelly Lee', 'Leo Choi'],
        },
      ],
    };
  },

  methods: {
    async closeLGPR() {
      try {
        await api.closeCurrentLGPR();
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      }
    },

    seeReport() {
      window.open(
        'https://s3.ap-northeast-2.amazonaws.com/mg-coaching/LGPRReport/LGPR_Report-Taylor_Lee.pdf',
        '_blank',
      );
    },
  },
};
</script>

<style lang="scss">
.actionButton {
  margin-top: 40px;
}
</style>
